import { render, staticRenderFns } from "./SettingsPasswordSection.vue?vue&type=template&id=2ebead3c&scoped=true"
import script from "./SettingsPasswordSection.vue?vue&type=script&lang=js"
export * from "./SettingsPasswordSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsPasswordSection.vue?vue&type=style&index=0&id=2ebead3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebead3c",
  null
  
)

export default component.exports